<user-navigation></user-navigation>

<div class="container-fluid">
  <div id="top"></div>
  <div class="row no-gutter">
    <div class="col-md-12 col-lg-4 profile-side-bar">
      <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-5 mb-md-0">
              <div id="page-redirection">
                <a routerLink="/user/profile">
                  <img src="../../../../assets/images/arrows/back_arrow.png">
                  Back to Account
                </a>
              </div>
              <h3 class="display-4 box-title mt-4 mt-md-4">Payment Method</h3><br>

              <div class="alert alert-success alert-dismissible fade show" role="success" *ngIf="success">
                <button type="button" class="close" data-dismiss="alert" (click)="success != success">&times;</button>
                Payment method successfully updated
              </div>

              <div class="alert alert-danger alert-dismissible fade show mt-2" role="success" *ngIf="updateError">
                <button type="button" class="close" data-dismiss="alert">&times;</button>
                Error on update
              </div>

              <div class="payment-method-update mt-md-5 mt-5 mb-md-3 mb-3 current-payment-method">
                <label class="font-weight-bold mb-md-0 mb-0">Active Card</label>
                <p class="font-weight-bold">**** **** **** {{lastFourDigits}}
                    <span class="pull-right">{{expireMonth}}/{{expireYear}}</span>
                </p>
              </div>

              <div>Enter your credit card information</div>
              <form action="/" method="post" id="payment-form">
                <div class="form-row-card">
                  <div id="card-element"></div>
                  <div id="card-errors" role="alert"></div>
                </div><br>
                <button class="btn btn-primary btn-block btn-submit">
                  Update
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
  </div>

  <!-- Modal Loader -->
  <modal-loader [modalText]="modalText"></modal-loader>

</div>

<footer-main></footer-main>
